'use strict';

document.addEventListener('DOMContentLoaded', function () {
    var
        // ----------------------------------------------------------
        // VARIABLES ------------------------------------------------
        // ----------------------------------------------------------
        elDevicesBtn        = document.getElementsByClassName('trailer-player-devices'),
        elCloseBtn          = document.getElementById('modal-close-trailer'),
        elModalBody         = document.getElementById('modal-body-trailer'),
        elModal             = jQuery('#modal-trailer-desktop, #modal-trailer-mobile'),

        // ----------------------------------------------------------
        // ELEMENTS -------------------------------------------------
        // ----------------------------------------------------------
        source              = document.createElement('source'),
        video               = document.createElement('video'),

        // ----------------------------------------------------------
        // FUNCTIONS ------------------------------------------------
        // ----------------------------------------------------------
        showTrailerDevices  = function(e) {
            var $trigger = jQuery(e.relatedTarget);

            if( $trigger && elModalBody) {
                // CREATE Video player tags
                source.src  = $trigger.attr('data-href');
                source.type = 'video/mp4';
                video.setAttribute('id', 'trailer-video-devices');
                video.setAttribute('class', 'video-js vjs-default-skin vjs-tech trailer-video vjs-big-play-centered vjs-controls-enabled vjs-has-started');
                video.setAttribute('width', '100%');
                video.style.width = "100%";
                video.setAttribute('height', '100%');
                video.style.height = "100%";
                video.setAttribute('controls', 'controls');
                video.setAttribute('preload', 'auto');
                video.setAttribute('autoplay', 'autoplay');
                video.setAttribute('data-setup', '{}');

                video.appendChild(source);
                elModalBody.appendChild(video);

                // PLAY Video player
                videojs(document.getElementById('trailer-video-devices'), {}, function() {}).play();
            }
        }
        ,
        hideTrailerDevices  = function() {
            // STOP Video player
            videojs(document.getElementById('trailer-video-devices')).dispose();
        };

    // ----------------------------------------------------------------
    // APPLY FUNCTIONS ------------------------------------------------
    // ----------------------------------------------------------------
    elModal.on( 'shown.bs.modal',  showTrailerDevices);
    elModal.on( 'hidden.bs.modal', hideTrailerDevices);
    });
